export function privacySettingsADA() {
  const ROOT_SEL = '.privacy_prompt_content';

  function applyRoles(root) {
    const section = root.querySelector('section');
    if (!section) return;

    // Ensure list semantics on the section
    if (section.getAttribute('role') !== 'list') {
      section.setAttribute('role', 'list');
    }

    // Ensure listitem semantics on each row
    section.querySelectorAll(':scope > .prmt-row').forEach(row => {
      if (row.getAttribute('role') !== 'listitem') {
        row.setAttribute('role', 'listitem');
      }
    });
  }

  const root = document.querySelector(ROOT_SEL);
  if (!root) return;

  // Run once (in case content already exists)
  applyRoles(root);

  // Observe dynamic injections (items created on button click)
  const observer = new MutationObserver(() => {
    applyRoles(root);
  });

  observer.observe(root, {
    childList: true,
    subtree: true
  });
}
